<template>
  <Card>
    <div class="p-3 persona-card">
      <div class="persona-card__header">
        <span class="fs-1"> {{ persona.config }} </span>
        <div class="persona-card__header__action-btn">
          <b-button
            @click="editPersona(index, 'edit')"
            class="click-icon-wrapper"
            :disabled="
              this.store.state.editState !== null &&
              this.store.state.editState === index
                ? true
                : false
            "
            ><PenSvg
          /></b-button>
          <b-button
            @click="deletePersona(index)"
            class="click-icon-wrapper"
            :disabled="
              this.store.state.editState !== null &&
              this.store.state.editState === index
                ? true
                : false
            "
            ><BinSvg
          /></b-button>
        </div>
      </div>
      <b-row class="pt-3">
        <b-col md="5" sm="auto" class="mb-1">
          <UserSvg />
          <span class="fs-6 pl-1">{{ persona.users }} Users</span>
        </b-col>
        <b-col class="mb-1 rightcol">
          <!-- <ServerSvg /><span class="fs-6 pl-1">{{
            store.state.allPersonaFormData[this.index][11].labelvalue
          }}</span> -->
        </b-col>
      </b-row>
      <b-row>
        <b-col md="5" sm="auto" class="mb-1">
          <span style="position:relative;top:2px"><MeterSvg /></span>

          <span class="fs-6 pl-1"
            >{{
              store.state.allPersonaFormData[this.index][10].value
            }}
            Hrs</span
          >
        </b-col>
        <b-col class="mb-1 rightcol">
          <span style="position:relative;top:2px"><BoxSvg /></span
          ><span class="fs-6 pl-1">{{
            store.state.allPersonaFormData[this.index][2].labelvalue
          }}</span>
        </b-col>
      </b-row>
    </div>
  </Card>
</template>
<script>
import Card from '../containers/Card.vue';
import UserSvg from '../../assets/icons/userprofile.svg';
import ServerSvg from '../../assets/icons/server.svg';
import PenSvg from '../../assets/icons/pen.svg';
import BinSvg from '../../assets/icons/bin.svg';
import MeterSvg from '../../assets/icons/meter.svg';
import BoxSvg from '../../assets/icons/box.svg';

import store from '../../store';

export default {
  name: 'PersonaCard',
  components: {
    Card,
    UserSvg,
    ServerSvg,
    PenSvg,
    BinSvg,
    MeterSvg,
    BoxSvg,
  },
  props: {
    persona: {
      name: String,
    },
    index: Number,
  },
  data: () => {
    return {
      store,
    };
  },
  methods: {
    deletePersona: id => {
      store.deletePersonaAction(id);
    },
    editPersona: (id, task) => {
      store.editPersona(id, task);
    },
  },
};
</script>

<style lang="scss" scoped>
.fs-1 {
  font-size: 19px;
  font-weight: 400;
  line-height: 14px;
}

.justify-content-end {
  display: flex;
}
.fs-6 {
  font-size: 14px;
  color: #8c8c8c;
}
.click-icon-wrapper {
  border: none;
  background: #fff;
  padding: 0px;
  margin: 0px 7px;
  text-decoration: none;
}
.persona-card {
  box-shadow: 0px 0px 24px rgba(217, 217, 217, 0.5);
  padding: 16px;

  // header
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h6 {
      margin-bottom: 0;
      padding: 0 !important;
    }

    &__action-btn {
      & > button {
        padding: 0;
        margin: 0 7px;
      }
    }
  }

  // content
  &__content {
    padding: 16px 0 0 0;

    & > *:not(:last-child) {
      margin-bottom: 6px;
    }

    &__list {
      padding: 0;
      margin: 0;

      & > li {
        display: inline-block;
        padding: 0 6px;
        color: #8c8c8c;
        font-size: 14px;

        &:first-child {
          padding-left: 0;
        }

        &:not(:first-child) {
          border-left: 1px solid #8c8c8c;
        }
      }
    }
  }
}
@media (max-width: 1280px) {
  .rightcol {
    padding: 0px 15px;
  }
  .col-md-5 {
    flex: none;
    max-width: 100%;
  }
}
</style>
